const _this = {

    $dom: {
		
    },

    vars: {
		
	},

    init : function() {
        $(window).on('load', _this.checkhash);
        $('#footer-menu-1 a').on('click', _this.checkhash);
        $('#header-menu .sub-menu a').on('click', _this.checkhash);
    },

    checkhash: function() {
        let url = window.location.href;
        if(url.indexOf('#') == -1) {
            return;
        } else {
            let hash = url.substring(url.indexOf('#') + 1);
            $('html, body').animate({
                scrollTop: $('[data-id="' + hash + '"]').offset().top
            }, 1000);
        }
    }

}

export default _this;